type Signal<TReturn> = AnyFunction<TReturn>;
type Arguments = unknown[];
type Deferred<TReturn> = () => TReturn;

export function lazy<TReturn = void>(fn: Signal<TReturn>, ...args: Arguments): Deferred<TReturn> {
  return function deferCall(): TReturn {
    return fn(...args);
  };
}
